export default class KformBuilderEditButtonsController {
	/* @ngInject */
	/**
	 * @param {import('angular').IScope} $scope
	 */
	constructor($scope) {
		this.$scope = $scope;

		/** @type {import('../list/kform-builder-list.controller').default | undefined} */
		this.builder = undefined;

		/** @type {any} */
		this.component = undefined;

		/** @type {boolean} */
		this.hideMoveButton = false;
	}

	$onInit() {
		this.formComponent = this.builder?.formComponents[this.component.type] ?? this.builder?.formComponents.custom;
	}
}
